import React from 'react';
import Dashboard from './Dashboard';
import UIToggleWrapper from '../../shared/UIToggleWrapper/UIToggleWrapper';
import HomePage from './HomePage';

const DashboardIndex = UIToggleWrapper(Dashboard, () => <HomePage />);

export default DashboardIndex;
